import SituacionLaboralCrud from './SituacionLaboralCrud'
export {SituacionLaboralCrud}
export default SituacionLaboralCrud
